import "@fontsource-variable/reem-kufi";
import { extendTheme } from "@chakra-ui/react";
import { theme as base } from "@chakra-ui/pro-theme";

const proTheme = extendTheme(base);

const extendedConfig = {
  colors: {
    ...proTheme.colors,
    brand: proTheme.colors.teal,
    primary: "#C23A3A",
    secondary: "#15505A",
  },
  components: {
    Progress: {
      baseStyle: {
        track: {
          background: "blackAlpha.100",
        },
        filledTrack: {
          bg: "#1495D4",
        },
      },
    },
  },
  fonts: {
    //heading: `'Open Sans', sans-serif`,
    //body: `'Reem Kufi Variable', sans-serif`,
  },
};
const theme = extendTheme(extendedConfig, proTheme);

export default theme;
